<template>
    <div class="simulationtable">
        <el-tabs v-model="activeName" class="simulationtable-wrap">
            <el-tab-pane label="节点" name="node">
                <el-table :data="nodeData" border style="width: 100%" class="custom-table"
                        header-row-class-name="custom-header"
                        row-class-name="custom-row"
                        max-height="400"
                        cell-class-name="custom-cell">
                    <el-table-column v-for="tbheader in nodeFiledTable" :key="tbheader.name" :label="tbheader.title">
                        <template slot-scope="scope">
                        {{scope.row[tbheader.name]}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="管道" name="pipe">
                <el-table :data="pipeData" border style="width: 100%" class="custom-table"
                        header-row-class-name="custom-header"
                        row-class-name="custom-row"
                        max-height="400"
                        cell-class-name="custom-cell">
                    <el-table-column v-for="tbheader in pipeFiledTable" :key="tbheader.name" :label="tbheader.title">
                        <template slot-scope="scope">
                        {{scope.row[tbheader.name]}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <div class="menu">
            <el-button type="primary" size="mini" @click="exportFile">导出</el-button>
        </div>
    </div>
</template>

<script>
/**
 * 结果集
 */
import { mapState } from 'vuex';
import _orderBy from 'lodash/orderBy';
import _filter from "lodash/filter";
import _cloneDeep from 'lodash/cloneDeep';
import {exportToExcel} from '@/api/simulation';

export default {
    name:"simulationtable",
    props:['nodeinfos','pipeinfos'],
    computed:{
        ...mapState('simulation',[
            'globalSet',
        ]),
    },
    data(){
        return {
            activeName:"node", // 显示面板

            nodeFiledTable:[{
                "name": "press",
                "title": "压力",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }, {
                "name": "flux",
                "title": "流量",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }], // 字段显示表格设置

            pipeFiledTable:[{
                "name": "flux",
                "title": "流量",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }, {
                "name": "velocity",
                "title": "流速",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }, {
                "name": "pressLoss",
                "title": "压损",
                "t_show": true,
                "g_show": true,
                "t_precision": 3,
                "t_length": 4,
                "g_precision": 3,
                "g_length": 4
            }], // 字段显示表格设置

            nodeData:[], // 节点数据
            pipeData:[], // 管道数据

        }
    },
    watch:{
        globalSet:{
            handler(){
                this.init_data();
            },
            deep:true
        }
    },
    mounted(){
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            // 获取节点字段
            let nodeHeader=this.globalSet.nodeHeader;
            if(nodeHeader){
                let nodeFiledTable=Object.values(nodeHeader);
                // 去掉不需要显示的属性
                nodeFiledTable=_filter(nodeFiledTable, function(o) { 
                    return o.t_show; 
                });
                this.nodeFiledTable=nodeFiledTable;
            }

            // 获取管道字段
            let pipeHeader=this.globalSet.pipeHeader;
            if(pipeHeader){
                let pipeFiledTable=Object.values(pipeHeader);
                // 去掉不需要显示的属性
                pipeFiledTable=_filter(pipeFiledTable, function(o) { 
                    return o.t_show; 
                });
                this.pipeFiledTable=pipeFiledTable;
            }

            // 对节点的数据精度进行处理
            for(let data of this.nodeinfos){
                let temp=_cloneDeep(data); // 避免修改原始数据，修改了原始数据之后，再次打开就会无法格式化了
                this.getText(nodeHeader,temp);
                this.nodeData.push(temp);
            }

            // 对管道的数据精度进行处理
            for(let data of this.pipeinfos){
                let temp=_cloneDeep(data); // 避免修改原始数据，修改了原始数据之后，再次打开就会无法格式化了
                this.getText(pipeHeader,temp);
                this.pipeData.push(temp);
            }

            // 处理节点数据
            this.nodeData=_orderBy(this.nodeData, ['id'], ['asc']);
            this.pipeData=_orderBy(this.pipeData, ['id'], ['asc']);
        },
        // 计算有效数字
        getText(header,props){
            for(let h in props){
                if(h=="name"||h=="_shape"||h=="id"){
                    continue;
                }
                let v=props[h]; // 数值
                let vh=header[h]; // 表头数据 

                let v_p=v;
                // 查找非零元素，判断有效位和小数位的长度
                let t_precision=vh.t_precision; // 有效位数
                let t_precision_t=0;  // 临时有效位数 
                if(t_precision>0){
                    let vt=v+"";
                    let va=vt.split("");
                    let v_p_t=[]; // 有效位数
                    for(let i=0;i<va.length;i++){
                        let t_v=va[i];
                        // 如果是零活着点的话，保存数字
                        if(t_v=="0"||t_v=="."){
                            v_p_t.push(t_v);
                        }else{
                            // 如果非零和非小数点点话，看看是否临时有效位数已经够了，不够就继续加
                            if(t_precision_t<=t_precision){
                                v_p_t.push(t_v);
                                t_precision_t++; // 临时有效位数加1
                            }
                        }
                    }
                    // 拼接最后的有效位数
                    v_p=v_p_t.join("");
                }
                        

                // 判断和小数点位数，那个短就取哪一个作为最后的显示值
                let t_length=vh.t_length; // 小数位数
                let v_t=v; // 格式化小数位数
                if(t_length>0){
                    v_t=v.toFixed(t_length); // 格式化小数位数
                }
                // 判断哪个数字更短，取哪一个
                v_p=v_p+"";
                v_t=v_t+"";
                if(v_p.length<=v_t.length){
                    v=v_p;
                }else{
                    v=v_t;
                }

                // 重新应用数值
                props[h]=v;
            }
            return props;
        },

        // 导出数据
        exportFile(){
            let json={
                node:{
                    header:this.globalSet.nodeHeader,
                    data:this.nodeinfos
                },
                pipe:{
                    header:this.globalSet.pipeHeader,
                    data:this.pipeinfos
                }
            }
            json=JSON.stringify(json);
            exportToExcel(json).then(response=>{
                // 导出
                let filename="仿真结果_"+this.$moment().format('yyyyMMDDHHmmss')+".xlsx"; // 文件名
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = [filename];
                a.click();
                window.URL.revokeObjectURL(url);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.simulationtable{
   .menu{
       text-align: right;
       margin-top: 5px;
   }
}

</style>